
import { VueSelect } from 'vue-select'
import { ValidationObserver } from 'vee-validate'
import { Component, Prop } from 'vue-property-decorator'
import { applicantStore, classifiersStore } from '@/store'
import Checkbox from '@/commons/components/core/Checkbox.vue'
import { ProviderInstance } from 'vee-validate/dist/types/types'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import ClassifierSelectWithLabel from '@/commons/components/core/ClassifierSelectWithLabel.vue'
import SelectWithSearch from '@/commons/components/core/SelectWithSearch.vue'

import {
    Classifier,
    ValidationError,
    ApplicationApplicant
} from '@/commons/types'

import {
    validatorIds,
    ApplicantValidationFieldName
} from '@/commons/constants/application'
import { ApplicationUtils } from '@/commons/utils/application'
import { LocaleMessages } from 'vue-i18n'

@Component({
    components: {
        Checkbox,
        VueSelect,
        SelectWithSearch,
        ClassifierSelectWithLabel
    }
})
export default class ApplicantInfo extends ValidationObserver {
    @Prop() excludedPlacesOfBirths: Array<string> | undefined
    @Prop() excludedEducations: Array<string> | undefined
    @Prop() excludedNationalities: Array<string> | undefined
    @Prop() excludedNativeLanguages: Array<string> | undefined

    domValidatorIds = validatorIds
    applicantPlaceOfBirthValidatorId = ApplicantValidationFieldName.BIRTH_COUNTRY

    get placeOfBirths (): Array<Classifier> {
        return classifiersStore.placeOfBirths
    }

    get educations (): Array<Classifier> {
        return classifiersStore.educations
    }

    get nationalities (): Array<Classifier> {
        return classifiersStore.nationalities
    }

    get nativeLanguages (): Array<Classifier> {
        return classifiersStore.nativeLanguages
    }

    get applicant (): ApplicationApplicant {
        return applicantStore.applicationApplicant
    }

    get blockTitle (): string | LocaleMessages {
        return this.$t(ApplicationUtils.getApplicantRelationTitle())
    }

    setDisabled (isDisabled: boolean): void {
        this.applicant.disabled = isDisabled
    }

    setPLaceOfBirth (classifierCode: string | null): void {
        this.applicant.birthCountry = classifierCode
    }

    setEducation (classifierCode: string): void {
        this.applicant.education = classifierCode || null
    }

    setNationality (classifierCode: string): void {
        this.applicant.nationality = classifierCode || null
    }

    setNativeLanguage (classifierCode: string): void {
        this.applicant.nativeLanguage = classifierCode || null
    }

    validatePlaceOfBirth (): void {
        (this.$refs.placeOfBirthValidator as ProviderInstance).validate()
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }
}
